import { first } from 'es-toolkit/compat';

// comments shortcuts keys
export const TOGGLE_SHOW_COMMENTS_SHORTCUTS = ['c', 'ב'];

// general shortcuts keys
export const TOGGLE_SHOW_HEATMAPS_SHORTCUTS = ['m', 'צ'];

// annotation shortcuts keys
export const TOGGLE_SHOW_ANNOTAIONS_SHORTCUTS = ['v', 'ה'];
export const HIDE_FILL_COLOR_SHORTCUTS = ['h', 'י'];
export const MOVE_TO_POLYGON_MODE = ['p', 'פ'];
export const MOVE_TO_ROI_MODE = ['r', 'ר'];
export const MOVE_TO_DELETE_MODE = ['d', 'ג'];
export const MOVE_TO_MODIFY_MODE = ['e', 'ק']; // 'e' for edit

export const ANNOTATION_SHORTCUTS = [
  {
    label: 'Polygon Mode',
    key: first(MOVE_TO_POLYGON_MODE),
    action: 'Switch to polygon drawing mode',
  },
  {
    label: 'ROI Mode',
    key: first(MOVE_TO_ROI_MODE),
    action: 'Switch to ROI drawing mode',
  },
  {
    label: 'Delete Mode',
    key: first(MOVE_TO_DELETE_MODE),
    action: 'Switch to delete mode',
  },
  {
    label: 'Modify Mode',
    key: first(MOVE_TO_MODIFY_MODE),
    action: 'Switch to modify mode',
  },
  {
    label: 'Show/Hide Fill Color',
    key: first(HIDE_FILL_COLOR_SHORTCUTS),
    action: 'Toggle fill color visibility',
  },
  {
    label: 'Show/Hide Annotations',
    key: first(TOGGLE_SHOW_ANNOTAIONS_SHORTCUTS),
    action: 'Toggle annotations visibility',
  },
];

export const COMMENTS_SHORTCUTS = [
  {
    label: 'Show/Hide Comments',
    key: first(TOGGLE_SHOW_COMMENTS_SHORTCUTS),
    action: 'Toggle comments visibility',
  },
];

export const GENERAL_SHORTCUTS = [
  {
    label: 'Show/Hide Heatmaps',
    key: first(TOGGLE_SHOW_HEATMAPS_SHORTCUTS),
    action: 'Toggle heatmaps visibility',
  },
];
